import request from '@/utils/request';

export const CAMPAIGN_PAGES_FETCH = 'CAMPAIGN_PAGES_FETCH';
export const CAMPAIGN_PAGE_FETCH = 'CAMPAIGN_PAGE_FETCH';
export const CAMPAIGN_PAGE_CREATE = 'CAMPAIGN_PAGE_CREATE';
export const CAMPAIGN_PAGE_UPDATE = 'CAMPAIGN_PAGE_UPDATE';
export const CAMPAIGN_PAGE_DELETE = 'CAMPAIGN_PAGE_DELETE';
export const CAMPAIGN_PAGE_SUBMIT = 'CAMPAIGN_PAGE_SUBMIT';
export const CAMPAIGN_PAGE_DUPLICATE = 'CAMPAIGN_PAGE_DUPLICATE';
export const CAMPAIGN_PAGE_LOADING = 'CAMPAIGN_PAGE_LOADING';

export const CAMPAIGN_PAGE_VIDEOS_FETCH = 'CAMPAIGN_PAGE_VIDEOS_FETCH';
export const CAMPAIGN_PAGE_VIDEO_CREATE = 'CAMPAIGN_PAGE_VIDEO_CREATE';
export const CAMPAIGN_PAGE_VIDEO_DELETE = 'CAMPAIGN_PAGE_VIDEO_DELETE';

export const fetchCampaignPages =
  (params = {}) =>
  async dispatch => {
    dispatch({ type: CAMPAIGN_PAGE_LOADING });
    const response = await request({ path: '/v1/campaign_pages', query: params });
    dispatch({ type: CAMPAIGN_PAGES_FETCH, payload: response });
    return response;
  };

export const fetchCampaignPage = id => async dispatch => {
  dispatch({ type: CAMPAIGN_PAGE_LOADING });
  const response = await request({ path: `/v1/campaign_pages/${id}` });
  dispatch({ type: CAMPAIGN_PAGE_FETCH, payload: response });
  return response;
};

export const createCampaignPage = params => async dispatch => {
  const response = await request({ path: '/v1/campaign_pages', method: 'POST', body: params });
  if (response.data || response.campaign_page) {
    dispatch({ type: CAMPAIGN_PAGE_CREATE, payload: response });
  }
  return response;
};

export const updateCampaignPage = (id, params) => async dispatch => {
  const response = await request({ path: `/v1/campaign_pages/${id}`, method: 'PATCH', body: params });
  if (response.data || response.campaign_page) {
    dispatch({ type: CAMPAIGN_PAGE_UPDATE, payload: response });
  }
  return response;
};

export const deleteCampaignPage = id => async dispatch => {
  const response = await request({ path: `/v1/campaign_pages/${id}`, method: 'DELETE' });
  dispatch({ type: CAMPAIGN_PAGE_DELETE, payload: { id } });
  return response;
};

export const submitCampaignPage = params => async dispatch => {
  const response = await request({ path: '/v1/campaign_pages/submit', method: 'POST', body: params });
  if (response.data || response.campaign_page) {
    dispatch({ type: CAMPAIGN_PAGE_SUBMIT, payload: response });
  }
  return response;
};

export const unpublishCampaignPage = id => async dispatch => {
  const response = await request({ path: `/v1/campaign_pages/${id}/unpublish`, method: 'POST' });
  if (response.data || response.campaign_page) {
    dispatch({ type: CAMPAIGN_PAGE_UPDATE, payload: response });
  }
  return response;
};

export const unarchiveCampaignPage = id => async dispatch => {
  const response = await request({ path: `/v1/campaign_pages/${id}/unarchive`, method: 'POST' });
  if (response.data || response.campaign_page) {
    dispatch({ type: CAMPAIGN_PAGE_UPDATE, payload: response });
  }
  return response;
};

export const duplicateCampaignPage = id => async dispatch => {
  const response = await request({ path: `/v1/campaign_pages/${id}/duplicate`, method: 'POST' });
  if (response.data || response.campaign_page) {
    dispatch({ type: CAMPAIGN_PAGE_DUPLICATE, payload: response });
  }
  return response;
};

export const fetchCampaignPageVideos = () => async dispatch => {
  const response = await request({ path: '/v1/campaign_page_videos' });
  dispatch({ type: CAMPAIGN_PAGE_VIDEOS_FETCH, payload: response });
  return response;
};

export const createCampaignPageVideo = formData => async dispatch => {
  const response = await request({
    path: '/v1/campaign_page_videos',
    method: 'POST',
    formData: true,
    formDataBody: formData
  });
  if (response.data || response.campaign_page_video) {
    dispatch({ type: CAMPAIGN_PAGE_VIDEO_CREATE, payload: response });
  }
  return response;
};

export const deleteCampaignPageVideo = id => async dispatch => {
  const response = await request({ path: `/v1/campaign_page_videos/${id}`, method: 'DELETE' });
  dispatch({ type: CAMPAIGN_PAGE_VIDEO_DELETE, payload: { id } });
  return response;
};

export const submitCampaignPageLead = (slug, formData) =>
  request({
    path: `/v1/public/campaign_pages/${slug}/leads`,
    method: 'POST',
    formData: true,
    formDataBody: formData
  });
